import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Text, Button } from '@brokerbay/design-components';

import { canBuildOrgAddress, buildOrgAddress } from 'utils';
import { useOrgOnboardingSelectContext } from '../../../contexts/OrgOnboardingSelectContext';

const OrgInfoPanel = () => {
  const { portalConfig, selectedOrg, setSelectedOrg } =
    useOrgOnboardingSelectContext();

  const org = useMemo(
    () => portalConfig?.orgs.find(o => o.id === selectedOrg),
    [portalConfig, selectedOrg],
  );

  if (!org) return null;

  const orgAddress = buildOrgAddress(org.address)[0];

  return (
    <Container>
      <OrgNameLabel textAlign="center" data-cy="text-org-name">
        {org.name}
      </OrgNameLabel>
      <OrgAddressLabel textAlign="center" data-cy="text-org-address">
        {orgAddress}
      </OrgAddressLabel>
      <ClearButton
        type="link"
        onClick={() => setSelectedOrg(undefined)}
        data-cy="button-clear-selected-brokerage"
      >
        Clear
      </ClearButton>
    </Container>
  );
};

export default OrgInfoPanel;

const OrgNameLabel = styled(Text)`
  margin-bottom: 10px;
`;

const OrgAddressLabel = styled(Text)`
  opacity: 45%;
  margin-bottom: 10px;
`;

const ClearButton = styled(Button)`
  margin-bottom: -5px;
`;

const Container = styled.div`
  width: 100%;
  border: 1px solid #f0f2f5;
  padding: 24px;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
`;
